export default {
    url: import.meta.env.VITE_API_URL,
    menuDomain: import.meta.env.VITE_MENU_DOMAIN,

    /** Mirrors the backend's ORDER_TYPES. */
    orderTypes: ["delivery", "table", "pickup"] as const,

    /**
     * Mirrors the backend's ORDER_STATUS_FLOW. The journey each kind of order takes, in order — the
     * card builds its buttons from this, so a delivery is never offered `ready` and a table is never
     * offered `delivering`. The API validates against its own copy, so this only decides what to show.
     */
    orderStatusFlow: {
        delivery: ["pending", "confirmed", "preparing", "delivering", "completed"],
        table: ["pending", "confirmed", "preparing", "ready", "completed"],
        pickup: ["pending", "confirmed", "preparing", "ready", "completed"],
    } as Record<string, string[]>,

    /** Mirrors the backend's ORDER_ABORT_STATUSES — reachable from anywhere before the end. */
    orderAbortStatuses: ["rejected", "cancelled"] as const,

    /** Mirrors the backend's ORDER_STATUSES. Every state an order can be in, for filtering by one. */
    orderStatuses: ["pending", "confirmed", "preparing", "ready", "delivering", "completed", "rejected", "cancelled"] as const,

    /** Mirrors the backend's MAX_ORDER_ITEM_QUANTITY — the ceiling a single line may carry. */
    maxOrderItemQuantity: 99,

    /** Mirrors the backend's ORDER_DATE_RANGES. How far back the orders list may be narrowed. */
    orderDateRanges: ["today", "week", "month", "year"] as const,

    /** Mirrors the backend's MAX_PRODUCT_PICTURES — the API rejects anything past it. */
    maxProductPictures: 8,

    /**
     * Mirrors the backend's MENU_LANGUAGES. Canonical order — a store's own list is always shown in
     * this order, never the order the boxes were ticked in, and the API re-filters through the same
     * list on every write. Adding a language here and in the backend is the whole change.
     */
    menuLanguages: ["ar", "en"] as const,
    /** Which of them render right-to-left. Read it instead of testing for `"ar"` by hand. */
    rtlLanguages: ["ar"] as const,
    /** Flag art for the language tiles, shared by the create-store picker and the settings card. */
    langFlags: { ar: "/images/arabic-lang.png", en: "/images/english-lang.png" } as Record<string, string>,
};
